import { render, staticRenderFns } from "./ArtistAlbumsAccordion.vue?vue&type=template&id=6298bb4c&"
import script from "./ArtistAlbumsAccordion.vue?vue&type=script&lang=js&"
export * from "./ArtistAlbumsAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports